import React from "react";
import LuvitComponent from "LuvitComponent";
import format from "lib/format";
import Modal from "lib/components/modal";
import config from "lib/config";
import moment from "moment";
import { getString } from "lib/translation";
import { GET, POST } from "lib/api";

const dateFormat = config.shortDateFormat.toUpperCase();
const mobileViewport = window.matchMedia("(max-width: 400px)").matches || false;

export default class RestartCourse extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "ActivityCentre");
  }

  async componentWillMount() {
    let coursesInfo = await GET(
      "v1/user/:personalId/onlinecourseinfo/:courseId",
      {
        personalId: this.props.personalId,
        courseId: this.props.course.courseId,
      },
    );

    this.setState({ coursesInfo, ready: true });
  }

  async reRegisterOnCourse(personalId, courseId) {
    await POST("v1/user/:personalId/onlinecourse/:courseId/reregister", {
      courseId,
      personalId,
    });
    this.props.refresh();
    this.setState({ registrationCompleted: true });
  }

  renderRestartInfo() {
    let styledFooterButtonMobileViewport = {
      height: "20px",
      lineHeight: "20px",
      marginBottom: "5px",
    };
    let repeatInfo = this.state.registrationCompleted
      ? getString(
          "ActivityCentre",
          "repeatCourseReRegistrationCompletedInfoText",
        )
      : getString("ActivityCentre", "repeatCourseInfoText");

    let qsFrom = "";
    if (luvit.GetQueryString("activityid"))
      qsFrom = "from=p&prid=" + luvit.GetQueryString("activityid");
    else qsFrom = "from=ml";

    let basePath = document.location.pathname;
    basePath = basePath.replace("activitycentre/activitycentre.aspx", "");

    let coursesInfo = this.state.coursesInfo.map((a) => (
      <div key={a.completedDate}>
        <p>
          {repeatInfo.replace("#1", moment(a.completedDate).format(dateFormat))}
        </p>
        {!this.state.registrationCompleted && (
          <button
            className="button-cta"
            onClick={() =>
              this.reRegisterOnCourse(
                this.props.personalId,
                this.props.course.courseId,
              )
            }
          >
            {getString("ActivityCentre", "repeatCourseWithNewResult")}
          </button>
        )}
        {this.state.registrationCompleted && (
          <a
            href={`${basePath}education/entercourse.aspx?${qsFrom}&courseid=${this.props.course.courseId}`}
          >
            {getString("ActivityCentre", "enter")}
          </a>
        )}
      </div>
    ));
    return coursesInfo;
  }

  render() {
    if (!this.state || !this.state.ready) return <div />;

    return (
      <Modal.Movable
        initiallyOpen
        title={this.props.course.title}
        dialogStyles={{ minWidth: "450px" }}
        afterClose={this.props.closeRestartCourse}
      >
        <div>
          <br />
          {this.renderRestartInfo()}
          <div className="flex flex-end">
            <button
              type="button"
              role="button"
              className="button-cancel"
              onClick={this.props.closeRestartCourse}
            >
              {this.l("close")}
            </button>
          </div>
        </div>
      </Modal.Movable>
    );
  }
}
